<template>
<div title="Perfil">
    <div class="vx-row">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
            </div>
            <div class="vx-col sm:w-1/3 w-full">
                <vs-avatar v-if="datos.avatar != ''" class="mx-auto my-6 block" size="100px" :src="$data_book+'archivos/avatar/'+datos.avatar" />
                <vs-avatar v-else class="mx-auto my-6 block" size="100px" src="https://cdn-icons-png.flaticon.com/512/166/166277.png" />
            </div>
        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Foto de perfil</span>
            <p style="font-size: 10px;">(Máximo 500 kb)</p>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input @change="obtenerImagen" id="file" type="file" accept="image/*" class="w-full" v-model="file" />
            <small v-if="msg" class="text-danger">{{ msg }}</small>
        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Cédula</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input readonly class="w-full" v-model="datos.cedula" />
        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Nombres</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="datos.nombre" />
        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Apellidos</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="datos.apellido" />
        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Fecha nacimiento</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input type="date" :max="today" class="w-full" v-model="datos.f_nacimiento" @change="validateDate" />
            <p v-if="dateError" style="color: red;">La fecha debe ser menor a la fecha actual.</p>

        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Genero</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-radio v-model="datos.genero" vs-value="0">Hombre</vs-radio>
            <vs-radio v-model="datos.genero" vs-value="1">Mujer</vs-radio>
        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Correo</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="datos.email" />
        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Teléfono</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="datos.telefono" />
        </div>
    </div>

    <div class="vx-row text-center">
        <div class="vx-col w-full sm:w-1/2">
            <vs-button @click="guardar" :disabled="btn" class="mr-3 mb-2" color="success">Guardar</vs-button>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import GeneralMixin from "@/mixins/GeneralMixin.js";
Vue.use(axios)
export default {
    mixins: [GeneralMixin],
    components: {},
    data() {
        return {
            file: '',
            usuario: [],
            password: '',
            passwordc: '',
            btn: false,
            error: '',
            limiteMegas: 1, //permitir maximo de megas
            bytes: 1048576, //para calculo de megas,
            pesoArchivo: 0,
            muyPesado: false,
            msg: '',
            usu_storage: [],
            datos: {},
            dateError: false,
            today:'',
        }
    },
    created() {},
    mounted() {
        let me = this
        me.usuario = JSON.parse(localStorage.getItem('usuario'));
        me.usu_storage = ('usuario del perfil', me.usuario[0])
        // console.log('datos usuario dl storage', me.usu_storage)
        me.datos = {
            'idusuario': me.usu_storage.idusuario,
            'avatar': me.usu_storage.avatar,
            'estado': 1,
            'genero': me.usu_storage.genero,
            'apellido': me.usu_storage.apellido,
            'cedula': me.usu_storage.cedula,
            'email': me.usu_storage.email,
            'id_group': me.usu_storage.id_group,
            'institucion_idInstitucion': me.usu_storage.institucion_idInstitucion,
            'nombre': me.usu_storage.nombre,
            'telefono': me.usu_storage.telefono,
            'f_nacimiento': me.usu_storage.f_nacimiento,
        }
        me.setTodayDate();
        // console.log('datos usuario', me.datos)
    },
    methods: {
        setTodayDate() {
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0'); // Enero es 0
            const year = today.getFullYear();

            this.today = `${year}-${month}-${day}`;
        },
        validateDate() {
            // console.log(this.datos.f_nacimiento)
            const currentDate = new Date();
            const selectedDate = new Date(this.datos.f_nacimiento);

            if (selectedDate >= currentDate) {
                this.dateError = true;
            } else {
                this.dateError = false;
            }
        },
        verificar() {
            var n = this.password.localeCompare(this.passwordc);
            if (n == 0) {
                this.btn = false;
                this.error = ""
            } else {
                this.btn = true;
                this.error = "Contraseñas no coinciden"
            }
        },
        async guardar() {
            let me = this
            me.btn = false;
            console.log(me.datos)
            if (me.msg) {
                me.f_notificaciones(me.msg, 'warning');
                return
            }
            if (me.datos.nombre == "") {
                me.f_notificaciones("Ingrese el nombre", 'warning');
                return
            }
            if (me.datos.apellido == "") {
                me.f_notificaciones("Ingrese el apellido", 'warning');
                return
            }
            if (me.datos.f_nacimiento == null || me.datos.f_nacimiento == "") {
                me.f_notificaciones("Ingrese su fecha de nacimiento", 'warning');
                return
            }
            if (me.datos.genero == null || me.datos.genero == undefined) {
                me.f_notificaciones("Seleccione el género", 'warning');
                return
            }
            if (me.datos.correo == "") {
                me.f_notificaciones("Ingrese el correo", 'warning');
                return
            }
            if (me.datos.telefono == "") {
                me.f_notificaciones("Ingrese el telefono", 'warning');
                return
            }
            if (me.dateError) {
                me.f_notificaciones("Corrija su fecha de nacimiento", 'warning');
                return
            }
            // return
            me.$vs.loading({
                color: '#046AE7'
            })
            let formData = new FormData();
            // formData.append('archivo', me.file);
            formData.append('idusuario', me.datos.idusuario);
            formData.append('cedula', me.datos.cedula);
            formData.append('nombre', me.datos.nombre);
            formData.append('apellido', me.datos.apellido);
            formData.append('f_nacimiento', me.datos.f_nacimiento);
            formData.append('email', me.datos.email);
            formData.append('telefono', me.datos.telefono);
            formData.append('genero', me.datos.genero);
            formData.append('estado', me.datos.estado);
            formData.append('password', me.password);
            formData.append('institucion_idInstitucion', me.datos.institucion_idInstitucion)
            formData.append('id_group', me.datos.id_group)
            me.$http.post(this.$server_url + 'guardarPerfil', formData)
                .then(function (response) {
                    // console.log('guardar perfil', response.data.usuario)
                    if (me.file == undefined || me.file == "") {
                        localStorage.setItem('usuario', JSON.stringify([response.data.usuario]));
                        me.f_notificaciones('Perfil actualizado', 'success')
                        // location.reload();
                        me.$vs.loading.close()
                    } else {
                        me.saveImagen()
                    }
                })
                .catch(() => {
                    me.$vs.loading.close()
                })
        },
        saveImagen() {
            let me = this;
            let formData = new FormData();
            formData.append('imagen', document.getElementById("file").files[0]);
            formData.append('idusuario', this.usuario[0].idusuario);
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            me.$http.post(this.$data_url + 'api/changeImagenPerfil', formData, config)
                .then(function (response) {
                    localStorage.setItem('usuario', JSON.stringify([response.data]));
                    me.file = '';
                    document.getElementById("file").value = ""
                    location.reload();
                })
                .catch(function () {
                    me.$vs.loading.close()
                })
        },
        obtenerImagen() {
            let me = this;
            // let file = e.target.files[0];
            var archivo = document.getElementById("file").files[0];
            let tamanio = archivo.size;
            // this.file = file;
            this.msg = '';
            this.muyPesado = false;
            // verificar tamaño de archivo
            if (tamanio > me.limiteMegas) {
                this.muyPesado = true;
                me.msg = "El tamaño de la imagen excede los 500 kbs"
                me.$vs.notify({
                    text: me.msg,
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                return
            }
            if (archivo.type == "image/png" || archivo.type == "image/jpeg" || archivo.type == "image/jpg") {
                // console.log('ok')
            } else {
                me.msg = 'Solo puede subir imagenes png/jpg/jpeg por favor'
            }
        },
    },
}
</script>

<style>
.uploading-image {
    display: flex;
}
</style>
